import React from "react";
import PropTypes from "prop-types";
import { Alert } from "antd";

const ValidationError = ({ children, style }) => {
  return (
    <Alert
      style={style}
      showIcon
      iconType={"warning"}
      type={"error"}
      message={
        "Following errors are found in your data selection. Please fix before you can run the report."
      }
      description={children}
      className={"test-validation-error"}
    />
  );
};

ValidationError.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object
};

export default ValidationError;



// WEBPACK FOOTER //
// ./src/views/components/validation_error/ValidationError.jsx